import * as React from 'react';

import { DataTable, Table, Spinner } from '../../components/common';
import { TextInput } from '../../components/forms';
import { Button, IconButton } from '../../components/buttons';
import { IconArrowRight } from '../../components/icons';
import Utils from '../../common/utils';

interface Props {
	customers: UserDetails[];
	history: any;
	isLoading: boolean;
	searchterm: string;
	onSearch: (e: any) => void;
	onClickComplete: () => void;
	onClickProspects: () => void;
	showComplete: boolean;
	setRedirectFromAdjudication: (redirect: boolean) => void;
	generateCombinedStatus: (userDetails: UserDetails) => React.ReactFragment;
	shouldShowBoldRow: (customer: UserDetails) => boolean;
}
interface State {
	page: number;
}
class CustomerList extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			page: 0
		};
	}

	onPageChange = (pageIndex: number) => {
		this.setState({ page: pageIndex });
	}

	render() {
		const { ...props } = this.props;
		return (
			<div className="content-set">
				<div className="table-options">
					<div className="btn-group table-filters">
						<div className="table-filter">
							<Button
								className={`btn-outline-secondary btn-block${props.showComplete ? ' active' : ''}`}
								onClick={props.onClickComplete}
							>
								Complete
							</Button>
						</div>
						<div className="table-filter">
							<Button
								className={`btn-outline-secondary btn-block${props.showComplete ? '' : ' active'}`}
								onClick={props.onClickProspects}
							>
								Applications
							</Button>
						</div>
					</div>
					<TextInput
						name="search"
						placeholder="Search"
						value={props.searchterm}
						onChange={props.onSearch}
						className="m-0 table-search"
					/>
				</div>
				{props.isLoading ?
					<Spinner className="d-block mx-auto" />
				:
					<DataTable
						TableComponent={p => <Table isDataTable={true}>{p.children}</Table>}
						columns={[
							{
								accessor: 'id',
								show: false
							},
							{
								Header: 'Full Name',
								accessor: 'fullName'
							},
							{
								Header: 'Email',
								accessor: 'email',
								Cell: (rowInfo: any) => {
									if (!props.showComplete && rowInfo.original.email) {
										return <a href={`mailto:${rowInfo.original.email}`} onClick={e => e.stopPropagation()}>{rowInfo.value}</a>;
									} else {
										return rowInfo.value;
									}
								}
							},
							{
								Header: 'Sign Up Date',
								accessor: 'createdDate',
								Cell: (rowInfo: any) => Utils.formatDate(rowInfo.value)
							},
							!props.showComplete ? {
								Header: 'Status',
								Cell: (rowInfo: any) => props.generateCombinedStatus(rowInfo.original)
							} : {
								show: false
							},
							{
								Header: 'Actions',
								className: 'p-0 td-actions',
								width: 100,
								Cell: (rowInfo: any) => {
									return (
										<IconButton
											title="Edit customer"
											className="btn-icon-secondary btn-icon-td"
											onClick={(e: any) => {
												e.stopPropagation(); // Prevent onClick conflict with tr onclick
												props.setRedirectFromAdjudication(false);
												if (rowInfo.original.stripeCustomerId) {
													return props.history.push(`/admin/customers/${rowInfo.row.id}/details`);
												} else {
													return props.history.push(`/admin/prospects/${rowInfo.original.id}/details`);
												}
											}}
										>
											<IconArrowRight />
										</IconButton>
									);
								}
							}
						]}
						data={props.customers}
						loading={props.isLoading}
						getTrProps={(state: any, rowInfo: any, column: any) => {
							const className = `tr interactive` + ((!props.showComplete && props.shouldShowBoldRow(rowInfo.original)) ? ` font-weight-bold` : ``);
							return {
								className,
								onClick: () => {
									props.setRedirectFromAdjudication(false);
									if (rowInfo.original.stripeCustomerId) {
										return props.history.push(`/admin/customers/${rowInfo.original.id}/details`);
									} else {
										return props.history.push(`/admin/prospects/${rowInfo.original.id}/details`);
									}
								}
							};
						}}
						noDataText="No customers found"
						onPageChange={this.onPageChange}
						page={this.state.page}
					/>
				}
			</div>
		);
	}
}
export default CustomerList;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/customers/CustomerList.tsx